module.exports = __webpack_public_path__ + "img/sec4_05.4cbc3571.png";